import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { Observable } from 'rxjs';
import { AddUserDialogComponent } from './add-user-dialog/add-user-dialog.component';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { UsersButtonRendererComponent } from 'projects/admin/src/lib/user-management/users-button-renderer/users-button-renderer.component';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { PlatformGroupRoleDto } from 'projects/shared/src/lib/models/PlatformGroupRoleDto';
import { AgGridUsersSettings } from './AgGridUsersSettings';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UsersDemoflagRendererComponent } from './users-demoflag-renderer/users-demoflag-renderer.component';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { Router } from '@angular/router';
import { UserProfile } from 'projects/shared/src/lib/models/UserProfile';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';

@Component({
  selector: 'user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserManagementComponent implements OnInit {

  @Input('paramTenant') paramTenant!:TenantDto;
  _addUserRole!:string;
  _db!:string;
  _targetIsTenantDB = true;

  // isAuthenticated$!: Observable<boolean>;
  // isAuthenticated!: boolean;

  rowData: UserDto[] = [];
  userData: UserDto[] = [];

  allProfiles: UserProfile[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridUsersSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  isLoadingResults = true;
  isRateLimitReached = false;
  isAddPossible = true;
  isFromSM = false;
  noUser = false;
  count = 0;

  _userRoles:string[] = [];

  constructor(public dialog: MatDialog,
    private accountService: AccountService,
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    private userProfileService: UserProfileService,
    public translate: TranslateService,
    private notificationService: NotificationService) { 
    }

  ngOnInit(): void {
    var self = this;
    console.log("-------> user-management paramTenant = ", this.paramTenant);

    //this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;
    if (this.paramTenant != undefined) {
      this.isFromSM = true;
      this.tenantService.tempTenantId = this.paramTenant.id;
      this.tenantService.tempTenantName = this.paramTenant.name;
    } else {
      this.paramTenant = new TenantDto();
    }


    
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //self._userRoles = data.role as Array<string>;
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) =>{
            if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") self._userRoles.push(role);
          })
          //console.log("------> user-management self.userRoles (userData): ", self._userRoles)
        }
      }
    });    
    let tenant = this.tenantService.currentTenantName;
    // console.log("-------> user-management tenant = ", tenant)
    this.tenantService.getToken(tenant).subscribe({
      next: (token) => {
        //self._userRoles = this.tenantService.getTenantRoles(token);
        var tenantRoles = this.tenantService.getTenantRoles(token);
        tenantRoles.forEach((role: string)=> {
          if (role != "" && !this._userRoles.includes(role)) self._userRoles.push(role);
        });
        //console.log("------> user-management self.userRoles (token): ", self._userRoles)
        //this.work(); // dann funktioniert F5 nicht!
      }
    });
    this.work();
  }

  work() {
    //let profileMap = new Map<string, UserProfileForCreation>();
    // this.isAuthenticated$ = this.oauthService.isLoggedIn;
    // this.isAuthenticated$.subscribe({
    //   next: (isAuthenticated) => {
    //     this.isAuthenticated = isAuthenticated;
    //   }
    // });

    this.filter = new GenericFilter();
    //console.log("-------> user management _userRoles = ", this._userRoles)
    this.aggridSettings = new AgGridUsersSettings(this.translate, this.tenantService, this._userRoles.includes('MANAGE_USERS') || this._userRoles.includes('TENANTADMIN') || this._userRoles.includes('admin'));
    //this.frameworkComponents = {buttonRenderer: new UsersButtonRendererComponent(this.paramTenant, this.dialog, this.oauthService, this.tenantService, this.translate, this.notificationService), flagRenderer: UsersDemoflagRendererComponent}
    this.frameworkComponents = {buttonRenderer: UsersButtonRendererComponent, flagRenderer: UsersDemoflagRendererComponent}
    this.gridOptions = this.aggridSettings.agGridUsersSettings as any;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'UserProfile';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        {
          // console.log("--------> user-management param tenantName = ", this.paramTenant.name);
          // console.log("--------> user-management isFromSM = ", this.isFromSM);
          let db:string = (this.paramTenant.name!= undefined)?this.paramTenant.name : this.tenantService.currentTenantName;
          console.log("--------> user-management getTenantUser db = ", db);
          if (db != this.tenantService.SystemManagerAbbreviation) {

            this.tenantService.getTenantUsers(db, this.filter).subscribe({
              next: (users) => {
                //console.log("-----------> tenant users: ", users)

                if (users.length > 0) {
                      users.forEach((user: UserDto) => {
                        //console.log("user confirmed = ", user.emailConfirmed)
                        if (!user.emailConfirmed) {
                          user.last_Name = "(not confirmed)";
                        } else {
                        }
                      });

                      this.rowData = users;
                      //this.rowData = this.userData.sort((a, b) => (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
                      //this.rowData = this.userData.sort();
                      //this.rowData = this.userData;
                      //console.log(">>>>>>>>>>>>>>>>>>>>> userData.length = ", this.userData.length)

                      this.rowData = this.rowData.slice(params.startRow, params.endRow);
                      //console.log(">>>>>>>>>>>>>>>>>>>>> rowData.length = ", this.rowData.length)
                      let lastRow = -1;
          
                      if (users.length <= params.endRow) {
                        lastRow = users.length;
                      }
                      console.log(">>>>>>>>>>>>>>>>>>>>> lastRow = ",lastRow)
                      params.successCallback(this.rowData, lastRow);
                      this.isLoadingResults = false;
                      this.isRateLimitReached = false;
                      //this.resultsLength = this.rowData.length;
          
                      this.gridApi.hideOverlay();
                      console.log(">>>>>>>>>>>>>>>>>>>>> lastRow1 = ",lastRow)

                } else { // no user
                  // this.noUser = true;
                  // this.isLoadingResults = false;
                  // this.isRateLimitReached = false;
                  // this.rowData = users.slice(this.filter.startRow, this.filter.endRow);
                  this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Benutzer vorhanden!")
                  let lastRow = -1;
    
                  // if (this.rowData.length <= this.filter.endRow) {
                  //   lastRow = this.rowData.length;
                  // }
                  if (users.length <= params.endRow) {
                    lastRow = users.length;
                  }
                  params.successCallback(this.rowData, lastRow);
                  // Flip flag to show that loading has finished.
                  this.isLoadingResults = false;
                  this.isRateLimitReached = false;
                  //this.resultsLength = this.rowData.length;
      
                  this.gridApi.hideOverlay();  
                }
              },
              error: (error: any) => {
                this.isLoadingResults = false;
                //this.isRateLimitReached = true;
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
                // console.log("------> error: ", error)
                this.notificationService.info("", error.error.developerMessage.Message)
                }
            });
          }
          else { // "SM"
            this.accountService.loadUsers(this.filter).subscribe({
              next: (users) => {
                users.forEach((user: UserDto) => {
                  console.log("user confirmed = ", user.emailConfirmed)
                  if (!user.emailConfirmed) {
                    //user.userName = user.userName + " (not confirmed)"; 
                    user.userName = "(not confirmed)"; 
                  }
                });
      
                this.rowData = users;
                this.rowData = this.rowData.slice(params.startRow, params.endRow);
                let lastRow = -1;
    
                if (users.length <= params.endRow) {
                  lastRow = users.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;
                //this.resultsLength = this.rowData.length;
    
                this.gridApi.hideOverlay();

                //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERSRETRIEVED"]}`);
              },
              error: (error: any) => {
                this.isLoadingResults = false;
                this.isRateLimitReached = true;
                this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
              }
            });
          }
        }
      }
    };
  }

 
  onGridReady(params: any) {
    this.gridApi = params.api;    
    this.gridApi.sizeColumnsToFit();    
    this.gridApi.setDatasource(this.ds);
  }

  addUser() {

    this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
      next: (tenantDto) => {
        if (tenantDto.maxUserCount >= 0 && this.rowData.length >= tenantDto.maxUserCount) {
          this.notificationService.error("", `Maximale Benutzeranzahl von ${tenantDto.maxUserCount} für diesen Mandanten erreicht!`);
          return;
        }
        const dialogRef = this.dialog.open(AddUserDialogComponent, {  height: '600px', width: '800px', data: this.noUser});
          dialogRef.afterClosed().subscribe((result: any) => { 
            console.log("-----> user-management: dialog result = ", result)
            if (result !== undefined) {
              let userDto:UserDto = result.userData.userDto;
              let inclTGR = result.userData.userDto.inclTGR;
              let copyUserId = (result.userData.userDto.copyUser != null) ? result.userData.userDto.copyUser.id : "undefined";      
              let projRolePairs = result.projRolePairs;
              // console.log("-----> user-management: copyUserId = ", copyUserId);
              // console.log("-----> user-management: pairs = ", projRolePairs);
              // console.log("-----> user-management: inclTGR = ", inclTGR);

              userDto.tenant = result.userData.userDto.tenant;
      
              this.notificationService.wait(undefined, "Neuer Benutzer wird angelegt ....");
              if (projRolePairs != null) {
                this.accountService.createUserWithPermissions(/*isTenantAdmin:*/ false, inclTGR, copyUserId, userDto, projRolePairs, this.tenantService.tempTenantName, this.tenantService.tempTenantId).subscribe({
                  next: (user) => {
                    this.rowData.splice(2, 0, user);
                    this.rowData.push(user);            
                    this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERADDED"]}`);
                      this.gridApi.refreshInfiniteCache();
                  },
                  error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
                });
              } else {
                this.accountService.createUser(userDto, /*isTenantAdmin:*/false, copyUserId, this.tenantService.tempTenantName, this.tenantService.tempTenantId).subscribe({
                  next: (user) => {
                    this.rowData.splice(2, 0, user);
                    this.rowData.push(user);            
                    this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERADDED"]}`);
                      this.gridApi.refreshInfiniteCache();
                  },
                  error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
                });
              }
            }
        },
          //error
        );
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant maxUserCount")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });


  }
}



